export const TEMPLATE_QUESTIONS_LABEL = 'Template Questions';
export const MY_QUESTIONS_LABEL = 'My Questions';
export const CREATE_NEW_LABEL = 'Create New';

export const TEMPLATE_QUESTIONS_TAB_VALUE = 'templateQuestions';
export const MY_QUESTIONS_TAB_VALUE = 'myQuestions';
export const CREATE_NEW_TAB_VALUE = 'createNew';

export const RESERVED_CATEGORY = 'Reserved';
export const ADDITIONAL_GUEST_CATEGORY = 'AdditionalGuest';
export const INPUT_TYPE_CATEGORY = 'InputType';
export const OTHER_CATEGORY = 'Other';

export const PERSONAL_CATEGORY = 'Personal';
export const PROFESSIONAL_CATEGORY = 'Professional';
export const SOCIAL_CATEGORY = 'Social';
export const NON_RESERVED_CATEGORIES = [PERSONAL_CATEGORY, PROFESSIONAL_CATEGORY, SOCIAL_CATEGORY];

export const TOP_LEVEL = 'topLevel';
export const GROUP_LEVEL = 'groupLevel';
